import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppShell from "../../components/AppShell";
import api from "../../lib/api";
import { Users, GraduationCap, School, Tablet, DollarSign, BookOpen, ShieldAlert } from "lucide-react";

export default function AdminDashboard() {
  const { t } = useTranslation();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setD(r.data)); }, []);
  if (!d) return <AppShell><div>{t("common.loading")}</div></AppShell>;
  const revenue = (d.revenue_cents || 0) / 100;
  return (
    <AppShell>
      <h1 className="font-adult font-bold text-3xl text-slate-900">{t("admin.title")}</h1>
      <p className="text-slate-600">{t("admin.subtitle")}</p>
      <div className="grid md:grid-cols-4 gap-4 mt-6">
        <Stat icon={Users} label={t("admin.total")} value={d.total_users} color="bg-blue-500" />
        <Stat icon={GraduationCap} label={t("admin.students")} value={d.students} color="bg-green-500" />
        <Stat icon={Users} label={t("admin.parents")} value={d.parents} color="bg-yellow-500" />
        <Stat icon={GraduationCap} label={t("admin.teachers")} value={d.teachers} color="bg-purple-500" />
        <Stat icon={School} label={t("admin.schools")} value={d.schools} color="bg-indigo-500" />
        <Stat icon={Tablet} label={t("admin.activations")} value={d.tablet_activations} color="bg-slate-800" />
        <Stat icon={DollarSign} label={t("admin.revenue")} value={revenue.toFixed(2)} color="bg-emerald-600" />
        <Stat icon={BookOpen} label={t("admin.sessions")} value={d.tutor_sessions} color="bg-orange-500" />
      </div>
      <div className="grid md:grid-cols-3 gap-4 mt-6">
        <div className="hb-card p-4"><div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{t("admin.scans")}</div><div className="mt-1 font-adult font-bold text-2xl">{d.homework_scans}</div></div>
        <div className="hb-card p-4"><div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{t("admin.paid")}</div><div className="mt-1 font-adult font-bold text-2xl">{d.paid_subscriptions}</div></div>
        <div className="hb-card p-4 flex items-center justify-between">
          <div><div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{t("admin.safety")}</div><div className="mt-1 font-adult font-bold text-2xl">{d.safety_flags}</div></div>
          <ShieldAlert className="w-6 h-6 text-red-600" />
        </div>
      </div>
    </AppShell>
  );
}
function Stat({ icon: Icon, label, value, color }) {
  return (
    <div className="hb-card p-4">
      <div className={`w-9 h-9 rounded-lg ${color} text-white flex items-center justify-center`}><Icon className="w-4 h-4" /></div>
      <div className="mt-2 font-adult font-bold text-2xl text-slate-900">{value}</div>
      <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">{label}</div>
    </div>
  );
}
